export const AcceptFileFormat = [
    "image/jpg", 
    "image/jpeg", 
    "image/png",
    "application/pdf",
];